const M__I_FIELDS = [
    "launch",
    "lifespan",
    "support",
    "stats",
    "planet",
    "overview"
];

const MIN_COL_SIZE = 390;

let missions = [], ssEl, mEl;

module.exports = {

    initMissions : function(missionData) {
        for (let key in missionData) {
            missions.push(missionData[key]);
            missions[missions.length - 1].mid = key;
        }
        missions.sort(function(a, b) {
            return (a.name < b.name) ? -1 : 1;
        });
        ssEl = document.getElementById('ss-info');
        mEl = document.querySelector('#ss-info-ml');
    },

    buildMissionList : function() {
        let cols = Math.floor(ssEl.clientWidth / MIN_COL_SIZE),
            items,
            buildCols = [],
            i, j, start, colEl, uEl, liEl, sEl;
        if(cols > 2) {
            cols = 3
        } else if(cols < 0) {
            cols = 1;
        }
        items = Math.ceil(missions.length / cols);
        while (mEl.hasChildNodes()) {
            mEl.removeChild(mEl.lastChild);
        }
        for(i = 0; i < cols; i++) {
            start = i * items;
            colEl = document.createElement('div');
            colEl.classList.add('ss-info-col');
            uEl = document.createElement('ul');
            colEl.appendChild(uEl);
            for(j = start; j < (start + items) && j < missions.length; j++) {
                liEl = document.createElement('li');
                sEl = document.createElement('span');
                liEl.setAttribute('data-planet', missions[j].planet.toLowerCase());
                liEl.setAttribute('data-mission', missions[j].mid);
                sEl.innerText = missions[j].name;
                liEl.appendChild(sEl);
                uEl.appendChild(liEl);
            }
            mEl.appendChild(colEl);
        }
        this.resetIframeSize();
    },

    resetName : function() {
        let nEl = document.getElementById('ss-m-name'),
            listEl = document.getElementById('ss-info-ml');
        nEl.style.display = 'none';
        listEl.classList.remove('hide');
        document.getElementById('ss-m-info').classList.remove('active');
        document.getElementById('ss-info').style.height = '';
        document.querySelectorAll('#ss-m-info>div').forEach(function (el) { el.classList.remove('active'); });
    },

    moveName : function(mEl) {
        let nEl = document.getElementById('ss-m-name'),
            sEl = mEl.querySelector('span'),
            sStyles = window.getComputedStyle(sEl),
            iEl = document.getElementById('ss-info'),
            listEl = document.getElementById('ss-info-ml'),
            rect = sEl.getBoundingClientRect(),
            iRect = iEl.getBoundingClientRect();
        //nEl.style.width = rect.width + 'px';
        nEl.style.height = rect.height + 20 + 'px';
        nEl.style.top = rect.top - iRect.top + 'px';
        nEl.style.left = rect.left - iRect.left - 15 + 'px';
        nEl.style.marginLeft = sStyles.getPropertyValue('margin-left');
        nEl.style.paddingLeft = sStyles.getPropertyValue('padding-left');
        nEl.style.fontSize = sStyles.getPropertyValue('font-size');
        nEl.style.lineHeight = sStyles.getPropertyValue('line-height');
        nEl.style.display = 'block';

        nEl.innerText = sEl.innerText;

        listEl.classList.add('hide');
        return nEl;
    },

    getIsLander: function (mission) {
        let curMission;
        for (var i = 0; i < missions.length; i++) {
            if(missions[i].mid === mission) {
                curMission = missions[i];
                break;
            }
        }
        return curMission && curMission.lander === 'true';
    },

    displayText: function (mission, missionData) {
        if (missionData[mission]) {
            let md = missionData[mission],
                contEl = document.getElementById('ss-info'),
                infoEl = document.getElementById('ss-m-info');
            for (let i = 0; i < M__I_FIELDS.length; i++) {
                document.querySelector('#ss-m-' + M__I_FIELDS[i] + ' span').innerHTML = md[M__I_FIELDS[i]];
            }
            infoEl.classList.add('active');
            contEl.style.height = infoEl.clientHeight + infoEl.offsetTop + 12 + 'px';
            window.setTimeout(function () {
                document.querySelectorAll('#ss-m-info>div').forEach(function (el) { el.classList.add('active'); });
            }, 100);
            this.resetIframeSize();
        }
    },

    displayInfo : function(mEl, missionData) {
        let nEl = this.moveName(mEl),
            self = this;
        window.setTimeout(function () {
            nEl.style.top = '15px';
            nEl.style.left = '0px';
            window.setTimeout(function () {
                self.displayText(mEl.getAttribute('data-mission'), missionData);
            }, 500);
        }, 500);
    },

    resetIframeSize: function() {
        if(window.parent && window.parent.adjustIframeHeight) {
            window.parent.adjustIframeHeight(document.body.clientHeight);
        }
    }
}
